export default {
    ca: {
        title: 'Informació del mapa',
        name: 'Títol',
        author: 'Autor',
        description: 'Descripció',
        lastUpdated: 'Darrera actualització',
        creationDate: 'Data de creació',
        attribution: 'Atribució',
        tags: 'Etiquetes',
        menu: {
            home: 'Inici',
        },
    },
    es: {
        title: 'Información del mapa',
        name: 'Título',
        author: 'Autor',
        description: 'Descripción',
        lastUpdated: 'Última actualitzación',
        creationDate: 'Fecha de creación',
        attribution: 'Atribución',
        tags: 'Etiquetas',
        menu: {
            home: 'Inicio',
        },
    },
    en: {
        title: 'Map Information',
        name: 'Title',
        author: 'Author',
        description: 'Description',
        lastUpdated: 'Last update',
        creationDate: 'Creation date',
        attribution: 'Attribution',
        tags: 'Tags',
        menu: {
            home: 'Home',
        },
    },
};



// WEBPACK FOOTER //
// ./src/map-viewer/components/info-modal/info-modal-translations.js